"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountPrefillableForm = void 0;
var inversify_1 = require("inversify");
var inversify_react_1 = require("inversify-react");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var DIProvider_1 = __importDefault(require("@CommonFrontend/DIProvider/DIProvider"));
var AngularSyncStore_1 = require("@CommonFrontend/Utils/AngularSyncStore");
var AutoFill_util_1 = require("@CommonFrontend/Utils/AutoFill/AutoFill.util");
var ValidateStrings_1 = require("@CommonFrontendBackend/Utils/ValidateStrings");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var pages_common_1 = require("@qwilr/pages-common");
var PrefillContextProvider_1 = require("../Springboard/PrefillContextProvider");
var UserPrefill_1 = require("../Springboard/UserPrefill");
var BasicFormStore_1 = require("./BasicFormStore");
var styles = __importStar(require("./PrefillCompatibleForm.css"));
var AuthenticationContext_1 = require("@CommonFrontend/Public/Identity/AuthenticationContext");
var UserPrefillGhost_1 = require("../Springboard/UserPrefillGhost");
var classnames_1 = __importDefault(require("classnames"));
var AcceptFormContextProvider_1 = require("../AcceptForm/AcceptFormContextProvider");
var mapAcceptStoreToPrefill = {
    name: "legalName",
    email: "email",
    legalEntity: "organisation",
};
var PrefillCompatibleBasicFormComponent = (function (_super) {
    __extends(PrefillCompatibleBasicFormComponent, _super);
    function PrefillCompatibleBasicFormComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.fieldErrors = [];
        _this.prefilledFields = [];
        _this.cleanupPrefilledFields = function () {
            _this.prefilledFields.forEach(function (field) {
                _this.acceptDataStore[field] = "";
            });
            _this.prefilledFields = [];
        };
        _this.handleValidate = function () {
            _this.fieldErrors = [];
            _this.props.fields.forEach(function (field) {
                var errorMessage = _this.validateField(field, _this.acceptDataStore[field.name]);
                if (errorMessage) {
                    _this.fieldErrors.push({ name: field.name, errorMessage: errorMessage });
                }
            });
            return _this.fieldErrors.length === 0;
        };
        _this.handleDevAutofill = function (random) {
            _this.acceptDataStore.name = "".concat(random(), " ").concat(random());
            _this.acceptDataStore.email = "".concat(random(), "@testing.com");
            _this.acceptDataStore.legalEntity = "".concat(random());
        };
        _this.handlePreviewAcceptAutofill = function () {
            var _a = (0, AutoFill_util_1.getRandomAutoFillObject)(), name = _a.name, email = _a.email, companyName = _a.companyName;
            _this.acceptDataStore.name = name;
            _this.acceptDataStore.email = email;
            _this.acceptDataStore.legalEntity = companyName;
        };
        _this.removeFieldError = function (field) {
            var index = _this.fieldErrors.findIndex(function (error) { return error.name === field.name; });
            if (index !== -1) {
                _this.fieldErrors.splice(index, 1);
            }
        };
        _this.validateField = function (field, value) {
            if (field.isOptional && !value) {
                return;
            }
            if (!value) {
                return "".concat(field.friendlyName, " cannot be empty");
            }
            var result = (0, ValidateStrings_1.checkBasicText)(value, { allowUrlsOrEmails: field.type === kaleidoscope_1.TextInputType.Email });
            if (result.valid === false) {
                return "".concat(field.friendlyName, " ").concat(result.error);
            }
        };
        _this.formatLabel = function (field, visualMode) {
            if (visualMode === "simple") {
                if (field.label === "Organization (optional)") {
                    return "Organization";
                }
                if (!field.isOptional) {
                    return "".concat(field.label, " *");
                }
            }
            return field.label;
        };
        _this.renderBasicField = function (field) {
            var fieldError = _this.fieldErrors.find(function (error) { return error.name === field.name; });
            return (react_1.default.createElement(AcceptFormContextProvider_1.AcceptFormContextConsumer, { key: field.name }, function (_a) {
                var visualMode = _a.visualMode, isPrintMode = _a.isPrintMode;
                return (react_1.default.createElement(kaleidoscope_1.TextInput, { label: _this.formatLabel(field, visualMode), value: _this.acceptDataStore[field.name], placeholder: visualMode === "standard" ? field.placeholder : undefined, onChange: function (value) {
                        _this.acceptDataStore[field.name] = value;
                        _this.removeFieldError(field);
                    }, error: fieldError === null || fieldError === void 0 ? void 0 : fieldError.errorMessage, size: isPrintMode ? kaleidoscope_1.TextInputSize.Small : kaleidoscope_1.TextInputSize.Large, className: (0, classnames_1.default)([
                        "accept-form-basic",
                        {
                            "accept-form-mode--simple": visualMode === "simple",
                            "accept-form-mode--print": isPrintMode,
                        },
                    ]), "data-test-id": "prefill-form-".concat(field.name) }));
            }));
        };
        props.registerImperativeHandlers({
            validate: _this.handleValidate,
            devFill: _this.handleDevAutofill,
            previewAutoFill: _this.handlePreviewAcceptAutofill,
        });
        return _this;
    }
    Object.defineProperty(PrefillCompatibleBasicFormComponent.prototype, "springboardPrefill", {
        get: function () {
            return this.props.springboardPrefill;
        },
        enumerable: false,
        configurable: true
    });
    PrefillCompatibleBasicFormComponent.prototype.componentDidMount = function () {
        var _this = this;
        this.disposePrefillReaction = (0, mobx_1.reaction)(function () { return _this.springboardPrefill; }, function (prefill) {
            (0, mobx_1.runInAction)(function () {
                if (prefill) {
                    var prefilledFields_1 = [];
                    _this.props.fields.forEach(function (field) {
                        var prefillItem = prefill[mapAcceptStoreToPrefill[field.name]];
                        if (!!prefillItem) {
                            _this.acceptDataStore[field.name] = prefillItem;
                            prefilledFields_1.push(field.name);
                        }
                    });
                    _this.prefilledFields = prefilledFields_1;
                }
                else {
                    _this.cleanupPrefilledFields();
                }
            });
        }, { fireImmediately: true });
    };
    PrefillCompatibleBasicFormComponent.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.disposePrefillReaction) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    PrefillCompatibleBasicFormComponent.prototype.render = function () {
        var _this = this;
        var isSpringboardPrefillAllowed = !this.props.isPreviewMode;
        var fieldsNotPrefilled = this.props.fields.filter(function (f) { return !_this.prefilledFields.includes(f.name); });
        return (react_1.default.createElement(AcceptFormContextProvider_1.AcceptFormContextConsumer, null, function (_a) {
            var visualMode = _a.visualMode;
            return (react_1.default.createElement("div", null,
                isSpringboardPrefillAllowed && react_1.default.createElement(UserPrefill_1.SpringboardUserPrefill, null),
                fieldsNotPrefilled.length > 0 && (react_1.default.createElement("div", { className: styles.formContainer({ visualMode: visualMode }) }, fieldsNotPrefilled.map(function (field) { return _this.renderBasicField(field); })))));
        }));
    };
    var _a, _b;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_a = typeof BasicFormStore_1.BasicFormAcceptDataStore !== "undefined" && BasicFormStore_1.BasicFormAcceptDataStore) === "function" ? _a : Object)
    ], PrefillCompatibleBasicFormComponent.prototype, "acceptDataStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_b = typeof Array !== "undefined" && Array) === "function" ? _b : Object)
    ], PrefillCompatibleBasicFormComponent.prototype, "fieldErrors", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], PrefillCompatibleBasicFormComponent.prototype, "prefilledFields", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], PrefillCompatibleBasicFormComponent.prototype, "springboardPrefill", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], PrefillCompatibleBasicFormComponent.prototype, "cleanupPrefilledFields", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], PrefillCompatibleBasicFormComponent.prototype, "handleValidate", void 0);
    PrefillCompatibleBasicFormComponent = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], PrefillCompatibleBasicFormComponent);
    return PrefillCompatibleBasicFormComponent;
}(react_1.default.Component));
var mountPrefillableForm = function (mountReactComponent, props, acceptData, consumerDataServiceBaseUrl, authAppBaseUrl, isPreviewMode, isPrintMode, $scope, $timeout, esignEnabled, acceptTelemetry) {
    return mountReactComponent(react_1.default.createElement(DIProvider_1.default, { container: function () {
            var container = new inversify_1.Container({ skipBaseClassChecks: true });
            container.bind(AngularSyncStore_1.AngularSyncServices.$).toConstantValue(!!$scope ? { $scope: $scope, $timeout: $timeout } : { disableSync: true });
            container.bind("acceptData").toConstantValue(acceptData);
            container.bind(BasicFormStore_1.BasicFormAcceptDataStore).toSelf().inSingletonScope();
            return container;
        } },
        react_1.default.createElement(AuthProvider, { isPreviewMode: isPreviewMode },
            react_1.default.createElement(AuthenticationContext_1.AuthenticationContextProvider, { authAppBaseUrl: authAppBaseUrl },
                react_1.default.createElement(PrefillContextProvider_1.PrefillContextProvider, { consumerDataServiceBaseUrl: consumerDataServiceBaseUrl, esignEnabled: esignEnabled, sellerHasSetName: !!acceptData.isPrefilled, acceptTelemetry: acceptTelemetry },
                    react_1.default.createElement(PrefillContextProvider_1.PrefillContextConsumer, null, function (_a) {
                        var loading = _a.loading, prefill = _a.prefill;
                        return loading ? (react_1.default.createElement(UserPrefillGhost_1.UserPrefillGhost, { esignEnabled: esignEnabled })) : (react_1.default.createElement(AcceptFormContextProvider_1.AcceptFormContextProvider, { visualMode: isPrintMode ? "simple" : "standard", isPrintMode: isPrintMode },
                            react_1.default.createElement(PrefillCompatibleBasicFormComponent, __assign({}, props, { springboardPrefill: prefill }))));
                    }))))));
};
exports.mountPrefillableForm = mountPrefillableForm;
var AuthProvider = function (_a) {
    var isPreviewMode = _a.isPreviewMode, children = _a.children;
    if (isPreviewMode || !window.Clerk) {
        return (react_1.default.createElement(pages_common_1.AuthenticationContextProvider, { isSignedIn: false, isInitialized: true, signOut: function () { return Promise.resolve(); }, getToken: function () { return Promise.resolve(""); } }, children));
    }
    return react_1.default.createElement(pages_common_1.ClientOnlyAuthenticationContextProvider, null, children);
};
